export default __webpack_public_path__ + "static/media/149.84d3dfc8.gif";